import { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { Label } from '@blueprintjs/core';
import * as configActions from "core/actions/configActions";
import initialState from "core/reducers/initialState";
import IPropertyRecord from "core/util/property/IPropertyRecord";
import IPropertyReference from "core/util/property/IPropertyReference";
import IPropertyType from "core/util/property/IPropertyType";
import { PropertyProvider } from "core/util/property/PropertyProvider";
import PropertyTypeRegistry from "core/util/property/PropertyTypeRegistry";

interface IPropertyFormProps {
	type: string | IPropertyType<any, any>; // type id
	reference: IPropertyReference;
	record?: IPropertyRecord<any>;
	actions?: typeof configActions;
}

class PropertyForm extends Component<IPropertyFormProps> {
	private type: IPropertyType<any, any>;

	private onChange(record: IPropertyRecord<any>) {
		const { reference, actions } = this.props;

		// const changed = {...record, value};

		actions.configPropertyAdd(reference, record);
	}

	public render() {
		const { type, record } = this.props;
		const t = type as IPropertyType<any, any>; // can you cast during object deconstruction above??

		return (
			<div style={{display: "grid", gridTemplateRows: "auto auto 1fr"}}>
				<h4>
					{record.displayName}
				</h4>

				<Label>
					Display Name
					<input
						className="bp3-input"
						type="text"
						placeholder={"New " + record.type}
						value={record.displayName}
						onChange={(e) => this.onChange({...record, displayName: e.target.value})}
					/>
				</Label>

				{t.getInput(record.value ? record.value : t.getDefaultValue(), (value) => {
					// set the value of the record from the registered input type
					this.onChange({...record, value});
				}, record)}
			</div>
		);
	}
}

function mapStateToProps(store = initialState, {type, reference}: IPropertyFormProps) {

	// look up the type if we need to
	if(typeof type === "string") {
		type = PropertyTypeRegistry.get(type);
	}

	// get the record from the store or create a new record with the type
	const stored = PropertyProvider.getRecord(reference, store);
	const record = stored ? stored : {value: null, type: type.name};

	return {
		type,
		record
	};
}

function mapActionsToProps(dispatch: Dispatch<typeof initialState>) {
	return {
		actions: bindActionCreators(configActions, dispatch)
	};
}


export default connect(mapStateToProps, mapActionsToProps)(PropertyForm);



// WEBPACK FOOTER //
// ./src/core/components/editor/properties/PropertyForm.tsx